import { Copy, MoreHorizontal, Pencil } from 'lucide-react';
import { Button } from 'components/ui/button';
import { Checkbox } from 'components/ui/checkbox';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';

/**
 * Team member column definitions for TanStack / shadcn DataTable.
 * Matches dashboard-01 plain muted header labels (not sort-button chrome).
 * @param {{ onEdit?: (member: object) => void }} [options]
 */
export function createTeamColumns({ onEdit } = {}) {
  return [
    {
      id: 'select',
      header: ({ table }) => (
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && 'indeterminate')
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) => (
        <span className="font-medium text-foreground">{row.getValue('name')}</span>
      ),
    },
    {
      accessorKey: 'lotName',
      header: 'Lot',
      cell: ({ row }) => row.getValue('lotName'),
    },
    {
      accessorKey: 'position',
      header: 'Position',
      cell: ({ row }) => row.getValue('position'),
    },
    {
      accessorKey: 'contacts',
      header: 'Contacts',
      cell: ({ row }) => (
        <span className="tabular-nums">{row.getValue('contacts')}</span>
      ),
    },
    {
      accessorKey: 'email',
      header: 'Email',
      cell: ({ row }) => {
        const email = row.getValue('email');
        return (
          <a className="text-primary hover:underline" href={`mailto:${email}`}>
            {email}
          </a>
        );
      },
    },
    {
      id: 'actions',
      enableHiding: false,
      cell: ({ row }) => {
        const member = row.original;
        return (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                className="data-table-row-actions team-soft-btn h-8 w-8 p-0"
              >
                <span className="sr-only">Open menu</span>
                <MoreHorizontal className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>Actions</DropdownMenuLabel>
              <DropdownMenuItem
                onClick={() => navigator.clipboard?.writeText(member.email || '')}
              >
                <Copy className="mr-2 h-4 w-4" />
                Copy email
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => onEdit?.(member)}>
                <Pencil className="mr-2 h-4 w-4" />
                Edit member
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        );
      },
    },
  ];
}
